import { render, staticRenderFns } from "./FormTextRegexInput.vue?vue&type=template&id=459de96a&"
import script from "./FormTextRegexInput.vue?vue&type=script&lang=js&"
export * from "./FormTextRegexInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports